import { ForestProductCommitmentDocumentList } from '../../../components/ForestProduct';

export function ForestProductCommitmentDocuments() {
  return <ForestProductCommitmentDocumentList />;
}
